let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hbX21")).then(() => parcelRequire('OD8to'));